export default __webpack_public_path__ + "static/art-innovation--mobile-8385f1b0fa9669038151ca8147c68d9d.png";